import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

import { targetUpdate } from './components/component_controller'

export class FullCheckController extends Controller {
  static targets = ['form', 'question', 'submitButton']

  declare formTarget: HTMLFormElement
  declare questionTargets: HTMLElement[]
  declare submitButtonTarget: HTMLButtonElement

  connect() {
    this.updateSubmitButton()
    document.addEventListener('turbo:frame-missing', this.rerenderPage)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-missing', this.rerenderPage)
  }

  answerAll() {
    this.questionTargets.forEach((questionTarget) => {
      targetUpdate(questionTarget, { value: 'yes' })
    })
    const formData = new FormData(this.formTarget)
    const formObject = Object.fromEntries(formData)
    const isFormValid = !!formObject['status_check[checked_by]']
    this.submitButtonTarget.disabled = !isFormValid
  }

  rerenderPage(event) {
    Turbo.visit('', { frame: '_top' })
  }

  updateSubmitButton() {
    const requiredFields = []
    const formData = new FormData(this.formTarget)
    const re = /status_check\[response\]\[questions\]\[(\d+)\]\[question\]/
    formData.forEach((_value, key) => {
      if (re.test(key)) {
        const answerKey = key.replace('[question]', '[answer]')
        requiredFields.push(answerKey)
      }
    })
    requiredFields.push('status_check[checked_by]')
    const formObject = Object.fromEntries(formData)
    const isFormValid = requiredFields.every((field) => formObject[field])

    this.submitButtonTarget.disabled = !isFormValid
  }
}
